import React, { useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { fileDownloadGetUrl } from "../../services/api/fileDownload";

const FileDownloadPage = () => {
    const { location } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const downloadFile = async () => {
            try {
                const response = await fileDownloadGetUrl(location);
                const url = response.url;

                const link = document.createElement('a');
                link.href = url;

                document.body.appendChild(link);
                link.click();
                link.remove();
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            } catch (error) {
                console.error('Error downloading file:', error);
                navigate('/');
            }
        };

        downloadFile();
    }, [location, navigate]);

    return <div>Processing file download...</div>;
};

export default FileDownloadPage;
